var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("街口支付說明")]),_c('ul',{staticClass:"has-type-decimal"},[_c('li',[_vm._v("使用街口支付恕不適用分期付款。")]),_c('li',[_vm._v("消費可使用街口幣折抵，折抵上限為結帳總金額 30% 。")]),_c('li',[_vm._v("街口支付接受街口聯名卡及帳戶付款。")]),_c('li',[_vm._v("付款額度限制：每筆 5 萬/每日 10 萬/每月 20 萬。")])])])
}]

export { render, staticRenderFns }